const doc = [({"en":({"js":({"admin":({"communication":({"index":({"communication":"Communication"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;